import * as React from 'react';
import LoadingIcon from '../../../components/LoadingIcon';
import { IDocumentHtmlReplyJsonData, useGetNDAHtmlApi } from '../../../services/useDocumentsApi';
import Moment from "moment";
import { IAccessRelationData, IAccessRelationRawData } from '../AccessDomainModels';

export interface IIHtmlContentRef {
	getVariables(): {
		isValid: boolean,
		variables: { [key: string]: string }
	},
};

interface IHtmlContentProps {
	issueId: number,
	templateName: string,
	relation: (IAccessRelationRawData | IAccessRelationData),
	onChangeReady: (result: IDocumentHtmlReplyJsonData, isError: boolean) => void;
}

export const HtmlContent = React.forwardRef((props: IHtmlContentProps, ref: React.RefObject<IIHtmlContentRef>) => {
	const content = React.useRef<HTMLDivElement>();

	const [setModel, result, isLoading, isError] = useGetNDAHtmlApi();

	React.useEffect(() => {
		if (!props.templateName) {
			props.onChangeReady(result, false);
			return undefined;
		}
		setModel({
			issueId: props.issueId,
			templateName: props.templateName,
			relation: {
				employee: props.relation.employee,
				resource: props.relation.resource,
				role: props.relation.role,
				variables: props.relation.documentVariables,

				company: props.relation.company,
				description: props.relation.description,

				environment: props.relation.environment,
				excluded: props.relation.excluded,
				from: dateToString(props.relation.from),
				to: dateToString(props.relation.to),

				login: props.relation.login,
				personAccountDescription: props.relation.personAccountDescription,
				personAccountType: props.relation.personAccountType,
				referenceNumber: props.relation.referenceNumber,
				systemName: props.relation.systemName,
				telephone: props.relation.telephone,
				email: props.relation.email,
				location: props.relation.location,
			}
		})
	}, [props.relation]);

	React.useEffect(() => {
		if (result && !isLoading) {
			props.onChangeReady(result, isError);
		}
	}, [result, isLoading]);

	React.useImperativeHandle(ref, () => {
		let api: IIHtmlContentRef = {
			getVariables: getVariables,
		}
		return api;
	});

	function dateToString(date: Moment.Moment | string): string {
		if (!date)
			return null;
		if (typeof date == 'string') {
			return date;
		}
		return date.toISOString();
	}

	function getVariables()
	{
		if (!content.current) {
			return {
				variables: null,
				isValid: true,
			}
		}

		var nodes = content.current.querySelectorAll("[data-name]");

		var variables: { [key: string]: string } = {};

		var isValid = true;
		for (let i = 0; i < nodes.length; i++) {
			let node = nodes[i] as HTMLElement;
			if (node.dataset.name) {
				if (!node.innerText && node.contentEditable)
				{
					isValid = false;
					node.classList.add("error");
				} else {
					node.classList.remove("error");
				}
				variables[node.dataset.name] = node.innerText;
			}
		}

		return {
			variables,
			isValid: isValid,
		}
	}

	if (!props.templateName) {
		return null;
	}

	if (isLoading) {
		return <div><LoadingIcon /></div>
	}
	if (isError) {
		return <p className="text-danger">Nieoczekiwany problem przy pobieraniu '{props.templateName}'.</p>
	}

	if (!result) {
		return null;
	}
	return <div ref={content} dangerouslySetInnerHTML={{ __html: result.html }} />
});